// test2675
(2675 && 0);
